var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:[
    { or_bg: _vm.lastClass },
    { a_last_deps: _vm.lastClass },
    { o_depth02: !_vm.lastClass },
    { active: _vm.isSelect },
    { meme: this.me },
  ]},[_c('div',[_c('b',{class:{ on: this.isOpen },on:{"click":_vm.toggle}}),_c('span',{on:{"click":_vm.MailOrgData}},[_vm._v(_vm._s(_vm.item.name)+" "),(this.item.kinds == 'Person')?_c('em',{staticClass:"tel"},[_vm._v(_vm._s(_vm.item.office))]):_vm._e()])]),_c('ul',{style:({ display: this.isBlock })},_vm._l((_vm.children),function(child,index){return _c('org-item',{key:index,attrs:{"item":child,"modalAutoOrg":_vm.modalAutoOrg,"createdOrg":_vm.createdOrg,"appDept":_vm.appDept,"appPath":_vm.appPath,"modalon":_vm.modalon},on:{"OpenFolder":_vm.OpenFolder,"PickItem":_vm.GetItem,"DelPickItem":_vm.DelItem}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }